import { FC, useState } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import imagePng from "images/tribyou_decorations/hero.png";
import SearchModal from "components/SearchModal/SearchModal";
import { useDispatch } from "react-redux";
import useWindowSize from "application/hooks/useWindowResize";
import { setMood } from "application/features/search/searchSlice";
import { useTranslation } from "react-i18next";

export interface SectionHeroProps {
  className?: string;
}

const SectionHero: FC<SectionHeroProps> = ({ className = "" }) => {
  const { t, ready } = useTranslation(['translation']);
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();
  const { width } = useWindowSize();

  if (!ready) return null;

  return (
    <>
      <SearchModal
        show={show}
        closeModal={() => setShow(false)}
      />
      <div
        className={`nc-SectionHero flex flex-col-reverse lg:flex-col relative ${className}`}
        data-nc-id="SectionHero"
      >
        <div className="flex flex-col lg:flex-row lg:items-center">
          <div className="flex-shrink-0 lg:w-1/2 flex flex-col items-start space-y-8 sm:space-y-10 pb-14 lg:pb-64 xl:pr-14 lg:mr-10 xl:mr-0">
            <h2 className="font-medium text-4xl md:text-5xl xl:text-7xl !leading-[114%] ">
              {t("translation:home.hero.title")}
            </h2>
            <span className="text-base md:text-lg text-neutral-500 dark:text-neutral-400">
              {t("translation:home.hero.description")}
            </span>
            {
              width > 768 ? <ButtonPrimary onClick={() => setShow(true)}>{t("translation:home.hero.actionButton")}</ButtonPrimary>
                :
                <ButtonPrimary onClick={() => dispatch(setMood(""))}>{t("translation:home.hero.actionButton")}</ButtonPrimary>
            }
          </div>
          <div className="flex-grow">
            <img className="w-full" src={imagePng} alt="hero" />
          </div>
        </div>
      </div>
    </>

  );
};

export default SectionHero;
